import { render, staticRenderFns } from "./add-student-opportunity.vue?vue&type=template&id=1b5f158b&scoped=true&"
import script from "./add-student-opportunity.vue?vue&type=script&lang=js&"
export * from "./add-student-opportunity.vue?vue&type=script&lang=js&"
import style0 from "./add-student-opportunity.vue?vue&type=style&index=0&id=1b5f158b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5f158b",
  null
  
)

component.options.__file = "add-student-opportunity.vue"
export default component.exports